import React from 'react';
import emailjs from 'emailjs-com';
import contactimg from '../../image/undraw_contact_us_-15-o2.svg'
const Contact = () => {


    let handleForm=(e)=>{
    e.preventDefault();

    emailjs.sendForm('service_dcshsrd', 'template_vaswdsi', e.target, 'user_z5hDeU9CvcnLGGweYvE69')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

      e.target.reset()
  };
    return (
        <div className='container mt-5 pb-5'>
           <div className='row d-flex align-items-center'>
                <div className='col-md-6' data-aos="zoom-out-left">
                    <img src={contactimg} alt="" className='img-fluid' />
                </div>
                <div className='col-md-6' data-aos="zoom-out-right">
                <form onSubmit={handleForm}>
                     <div className="mb-3">
                    <label  className="form-label">Your Name</label>
                    <input type="text" name="name" className="form-control" id="exampleFormControlInput1" placeholder="Type Your Name..."/>
                    <label className="form-label my-3">Email address</label>
                    <input type="email" name="email" className="form-control" id="exampleFormControlInput1" placeholder="Type Your Email Address..."/>
                    </div>
                    <div className="mb-3">
                    <label  className="form-label">Write Message</label>
                    <textarea className="form-control" name="message" id="exampleFormControlTextarea1" rows="3"></textarea>
                    </div>
                    <button type='submit' className='btn btn-success'> Send </button>
                </form>
                </div>
           </div>
        </div>
    );
};

export default Contact;